// Hack for static inline strings 
// Example usage: 	<div data-text-locale='{"EN":"English text", "SE":"Swedish text", "NO":"Norweigan text", "DK":"Danish text", "FI":"Finnish text" }'> Translation appears here </div>

window.SMTX.DataTextLocale = (function () {
  if ($('[data-text-locale]').length <= 0) {
    return false;
  }

  var CURRENT_SITE = getCurrentSite();

  $('[data-text-locale]').each(function () {
      var $me = $(this);
      var textJson = JSON.parse($me.attr('data-text-locale'));
     $me.text( textJson[CURRENT_SITE] );
  });



  function getCurrentSite(){
    var currentLang = $('html').attr('lang').slice(0, 2); // eg from sv-SE to sv
    var currentSite;

    switch (currentLang) {
      case 'en':
        currentSite = 'EN';
        break;
      case 'sv':
        currentSite = 'SE';
        break;
      case 'nb':
        currentSite = 'NO';
        break;
      case 'da':
        currentSite = 'DK';
        break;
      case 'fi':
        currentSite = 'FI';
        break;
      case 'de':
        currentSite = 'DE';
        break;
      default:
        currentSite = 'EN';
      // code block
    }

    return currentSite;

  }

  return {

  };

})();
